module.exports = __webpack_public_path__ + "img/contact99.075109a9.jpg";